import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "../../App.css";

Modal.setAppElement("#root");

export const ModalBox = ({
	show,
	toggleModel,
	children,
	modalClass,
	closeTimeoutMS = 0,
}) => {
	const [overlayStyle, setOverlayStyle] = useState({
		backgroundColor: "rgba(0, 0, 0, 0)",
		transition: "background-color 3s ease-in-out",
	});

	useEffect(() => {
		if (show) {
			setTimeout(() => {
				setOverlayStyle({
					backgroundColor: "rgba(0, 0, 0, 0.6)",
					transition: "background-color .5s ease-in-out",
				});
			}, 0); // Update style after the component is mounted
		} else {
			setOverlayStyle({
				backgroundColor: "rgba(0, 0, 0, 0)",
				transition: "background-color .5s ease-in-out",
			});
		}
	}, [show]);
	// const overlyObject = {
	// 	backgroundColor: "#00000099",
	// 	transitionDuration: "3s",
	// };
	return (
		<Modal
			className={` remove-perspective modal-dialog-centered ${modalClass}`}
			isOpen={show}
			contentLabel="onRequestClose Example"
			onRequestClose={toggleModel}
			shouldCloseOnOverlayClick={true}
			style={{ overlay: overlayStyle }}
			closeTimeoutMS={closeTimeoutMS}
		>
			{children}
		</Modal>
	);
};

export default ModalBox;
